import React from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Skeleton,
} from '@mui/material';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

import PIIFileUploadPanel from './PIIFileUploadPanel/PIIFileUploadPanel';
import PIIAnonymizerHelp from './PIIAnonymizerHelp';
import AsyncJobsList from './AsyncJobsList/AsyncJobsList';

const PIIAnonymizerPage = () => {
  const { isLoggedIn, user, isLoading } = useAuth();
  const { t } = useTranslation();

  const renderSkeleton = () => (
    <>
      <Sidebar user={user} />
      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Skeleton variant="text" width={260} height={50} />
          <Skeleton variant="text" width={420} height={32} sx={{ mb: 3 }} />

          <Grid container spacing={3}>
            <Grid item xs={12} lg={6}>
              <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
            </Grid>
            <Grid item xs={12} lg={6}>
              <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );

  if (!isLoggedIn || isLoading) {
    return renderSkeleton();
  }

  return (
    <>
      <Sidebar user={user} />

      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            mb: 5, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Grid container spacing={4}>
            
            {/* Header Section */}
            <Grid item xs={12}>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: 'text.primary' }}>
                {t('PIIAnonymizerPage.title', 'Anonymizácia obsahu dokumentov (PDF, DOCX)')}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                {t('PIIAnonymizerPage.subtitle', 'Anonymizujte citlivý text alebo súbory pred ich zdieľaním.')}
              </Typography>
            </Grid>

            {/* Help Banner */}
            <Grid item xs={12}>
              <PIIAnonymizerHelp t={t} />
            </Grid>

            {/* Side-by-Side Content Area */}
            <Grid item xs={12} lg={6}>
              <PIIFileUploadPanel />
            </Grid>

            {/* Async Jobs History */}
            <Grid item xs={12} lg={6}>
              <AsyncJobsList />
            </Grid>

          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default PIIAnonymizerPage;